import { FC, useState } from 'react';
import { useFetchCards } from '../../../hooks/payment/useFetchCards';
import ErrorNotification from '../../Common/ErrorNotification';
import LoadingIndicator from '../../Common/LoadingIndicator';

type Props = {
  savedCardHandler: (cardId: number) => void;
};

const SavedCardOptions: FC<Props> = ({ savedCardHandler }) => {
  const { cards, error, fetching, fetchSavedCards } = useFetchCards();
  const [card, setCard] = useState<string | null>(null);

  const onSelectCard = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCard(event.target.value);
  };

  const onSubmithandler = () => {
    savedCardHandler(parseInt(card!));
  };

  return (
    <>
      <div className='mt-7 mb-8'>
        {fetching && <LoadingIndicator message='' />}
        {!fetching &&
          cards.length !== 0 &&
          cards.map((card) => (
            <label key={card.id} className='d-flex flex-stack mb-5 cursor-pointer'>
              <span className='d-flex align-items-center me-2'>
                <span className='d-flex flex-column'>
                  <span className='fw-bolder text-hover-primary fs-7'>{card.card.type}</span>
                  <span className='fs-8 fw-bold text-gray-400'>{`${card.card.first_6digits} ****** ${card.last_four_digits} expiring ${card.card.expiry}`}</span>
                </span>
              </span>

              <span className='form-check form-check-custom form-check-solid'>
                <input name='payment_method' className='form-check-input' type='radio' value={card.id} onChange={onSelectCard} />
              </span>
            </label>
          ))}
        {error && <ErrorNotification message='Error Fetching Cards' retry={true} retryHandler={fetchSavedCards} />}
      </div>

      {card && (
        <button className='btn btn-primary w-100' onClick={onSubmithandler}>
          Disburse Loan
        </button>
      )}
    </>
  );
};

export default SavedCardOptions;
